import React from "react";
import { Spinner } from "theme-ui";

export const LoadingOverlay: React.FC = () => (
  <div className="loading-overlay">
    <Spinner size="28px" sx={{ color: "text" }} />
  </div>
);
